import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // The bank changes when someone ingests or reviews, not continuously. Refetching
      // on every window focus makes a reviewer's table jump under them mid-read.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // A 400 means the request was wrong and will be wrong again; only retry the
      // ones that might not be.
      retry: (failureCount, error) =>
        failureCount < 2 && !(error instanceof Error && /^\s*(4\d\d|question |job )/.test(error.message)),
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      {/* nginx serves index.html for any path that is not a file (ops/nginx/qbank.conf),
          which is what lets the router own the URL. */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
